import { ListFilter } from 'lucide-react'
import { Suspense, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { LayoutPage } from '@/components/layout/page'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { TEMPLATE_CATEGORIES } from '@/config/templates'
import { useIdCompany, useRBAC } from '@/lib/hooks'
import { TemplateCards } from '@/routes/templates/template-cards'
import { TemplateCardsFallback } from '@/routes/templates/template-cards/fallback'

export const TemplatesPage = () => {
  const { idCompany } = useIdCompany()
  const { rbac } = useRBAC()
  const [searchParams] = useSearchParams()
  const search = searchParams.get('search') ?? ''
  const categoryParam = searchParams.get('category') ?? 'all'
  const [filterTerm, setFilterTerm] = useState(search)
  const [category, setCategory] = useState(categoryParam)

  useEffect(() => {
    rbac.company(idCompany).apps.create.ensure()
    rbac.company(idCompany).databases.create.ensure()
  }, [rbac, idCompany])

  return (
    <LayoutPage browserTitle="Templates" fallback={<CardSkeleton />}>
      <div className="pb-25 grid gap-4 pt-1">
        <div className="flex items-center gap-2">
          <Input
            className="bg-background max-w-sm shadow-sm"
            placeholder="Search templates..."
            aria-label="Search templates"
            value={filterTerm}
            onChange={(e) => setFilterTerm(e.target.value)}
          />
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger
              className="h-8 bg-background shadow-sm"
              aria-label="Filter by category"
            >
              <ListFilter />
              <SelectValue placeholder="Filter by category" />
            </SelectTrigger>
            <SelectContent side="top">
              {Object.entries(
                Object.assign({ all: 'All' }, TEMPLATE_CATEGORIES)
              ).map(([category, displayName]) => (
                <SelectItem key={category} value={category}>
                  {displayName}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <Suspense fallback={<TemplateCardsFallback />}>
          <TemplateCards filterTerm={filterTerm} category={category} />
        </Suspense>
      </div>
    </LayoutPage>
  )
}
